export function humanize(data, type) {
  var nowTime = parseInt(Date.now() / 1000);
  var publishTime = parseInt(data);
  var diff = nowTime - publishTime;

  var formatTime = null;
  var days = parseInt(diff / 86400);
  var day = parseInt(diff / 86400);
  var hour = diff % 86400;
  var hours = parseInt(hour / 3600);
  var minute = hour % 3600;
  var minutes = parseInt(minute / 60);
  var second = minute % 60;
  var seconds = parseInt(second);

  var s = new Date(publishTime * 1000);
  var y = s.getFullYear();
  var M = s.getMonth() + 1;
  var d = s.getDate();
  var h = s.getHours();
  var m = s.getMinutes();

  function transform(single) {
    return single >= 10 ? single : '0' + single;
  }

  function getTodayZero() {
    var zero = new Date();
    zero.setHours(0);
    zero.setMinutes(0);
    zero.setSeconds(0);
    return zero;
  }

  if (publishTime < getTodayZero().getTime() / 1000) {
    days++;
  }

  var nowDate = parseInt(new Date().getDate());
  var publishDate = parseInt(new Date(publishTime * 1000).getDate());
  var thisYear = parseInt(new Date().getFullYear());
  var publishYear = parseInt(new Date(publishTime * 1000).getFullYear());

  var showTime = {
    time1: function() {
      if (day <= 0 && hours <= 0 && minutes <= 5) {
        return '刚刚';
      }
      return null;
    },

    time2: function() {
      if (day <= 0 && hours <= 0 && minutes > 5) {
        return minutes + ' 分钟前';
      }
      return null;
    },

    time3: function() {
      if (day <= 0 && hours > 0 && hours <= 3) {
        return hours + ' 小时前';
      }
      return null;
    },

    time4: function() {
      if (day <= 0 && hours > 3) {
        if (nowDate === publishDate) {
          return '今天 ' + transform(h) + ':' + transform(m);
        } else {
          return '昨天 ' + transform(h) + ':' + transform(m);
        }
      }
      return null;
    },

    time5: function() {
      if (day > 0 && day <= 1) {
        if (nowDate === publishDate + 1) {
          return '昨天 ' + transform(h) + ':' + transform(m);
        } else {
          return '前天 ' + transform(h) + ':' + transform(m);
        }
      }
      return null;
    },

    time6: function() {
      if (type === 'video') {
        if (day > 1) {
          const month = M < 10 ? `0${M}` : M;
          const day = d < 10 ? `0${d}` : d;

          if (thisYear !== publishYear) {
            return `${y}-${month}-${day}`;
          } else {
            return `${month}-${day}`;
          }
        }
        return;
      }
      if (day > 1) {
        if (thisYear !== publishYear) {
          return y + '年' + M + '月' + d + '日';
        } else {
          return M + '月' + d + '日';
        }
      }
      return null;
    },
  };

  for (var index in showTime) {
    if (showTime[index]()) {
      formatTime = showTime[index]();
    }
  }

  return formatTime;
}
